module.exports = __webpack_public_path__ + "assets/checkTips.e78f2ee7af19b0b58f281376e7b6a2d1.png";